import i01d from './01d.svg'
import i01n from './01n.svg'

import i02d from './02d.svg'
import i02n from './02n.svg'

import i03d from './03d.svg'
import i03n from './03n.svg'

import i04d from './04d.svg'
import i04n from './04n.svg'

import i09d from './09d.svg'
import i09n from './09n.svg'

import i10d from './10d.svg'
import i10n from './10n.svg'

import i13d from './13d.svg'
import i13n from './13n.svg'

import i50d from './50d.svg'
import i50n from './50n.svg'

export const images = {
    '01d': i01d,
    '01n': i01n,
    '02d': i02d,
    '02n': i02n,
    '03d': i03d,
    '03n': i03n,
    '04d': i04d,
    '04n': i04n,
    '09d': i09d,
    '09n': i09n,
    '10d': i10d,
    '10n': i10n,
    '13d': i13d,
    '13n': i13n,
    '50d': i50d,
    '50n': i50n
}